import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { InsightKey } from "@tandemdiabetes/sugarmate-api-react-client"

const upToNow = null
const sinceWakeUp = 0
const threeHours = 3
const sixHours = 6
const twelveHours = 12
const oneDay = 24
const threeDays = 3 * 24
const oneWeek = 7 * 24
const twoWeeks = 14 * 24
const thirtyDays = 30 * 24
const sixtyDays = 60 * 24
const ninetyDays = 90 * 24

// all ranges except for "up to now" and "current rate"
const allRanges = [
  sinceWakeUp,
  threeHours,
  sixHours,
  twelveHours,
  oneDay,
  threeDays,
  oneWeek,
  twoWeeks,
  thirtyDays,
  sixtyDays,
  ninetyDays,
]

const oneDayOrShorter = [
  sinceWakeUp,
  threeHours,
  sixHours,
  twelveHours,
  oneDay,
]

const oneDayOrLonger = [
  oneDay,
  threeDays,
  oneWeek,
  twoWeeks,
  thirtyDays,
  sixtyDays,
  ninetyDays,
]

/*
 * all "average" tiles should use "oneDayOrLonger"
 * most tiles use "allRanges"
 */
export function copyInsightRangesByKey(): Record<
  InsightKey,
  Insight["range"][]
> {
  return {
    [InsightKey.ExerciseAverageDuration]: [...oneDayOrLonger],
    [InsightKey.ExerciseTotalDuration]: [...allRanges],
    [InsightKey.FoodAverageCalories]: [...oneDayOrLonger],
    [InsightKey.FoodAverageCarbs]: [...oneDayOrLonger],
    [InsightKey.FoodAverageFat]: [...oneDayOrLonger],
    [InsightKey.FoodAverageFiber]: [...oneDayOrLonger],
    [InsightKey.FoodAverageProtein]: [...oneDayOrLonger],
    [InsightKey.FoodTotalCalories]: [...allRanges],
    [InsightKey.FoodTotalCarbs]: [...allRanges],
    [InsightKey.FoodTotalFat]: [...allRanges],
    [InsightKey.FoodTotalFiber]: [...allRanges],
    [InsightKey.FoodTotalProtein]: [...allRanges],
    [InsightKey.LiquidAverage]: [...oneDayOrLonger],
    [InsightKey.LiquidTotal]: [...allRanges],
    [InsightKey.GlucoseAverageReadingBedtime]: [...oneDayOrLonger],
    [InsightKey.GlucoseAverageReadingWakeUp]: [...oneDayOrLonger],
    [InsightKey.GlucoseAverageReading]: [...allRanges],
    [InsightKey.GlucoseCoefficientOfVariation]: [...allRanges],
    [InsightKey.GlucoseFluxGrade]: [...allRanges],
    [InsightKey.GlucoseHighsAndLows]: [...allRanges],
    [InsightKey.GlucoseManagementIndicator]: [...allRanges],
    [InsightKey.GlucoseMedianReading]: [...allRanges],
    [InsightKey.GlucosePercentageAbove]: [...allRanges],
    [InsightKey.GlucosePercentageBelow]: [...allRanges],
    [InsightKey.GlucosePercentageDistribution]: [...allRanges],
    [InsightKey.GlucosePercentageWithin]: [...allRanges],
    [InsightKey.GlucoseQuartiles]: [...allRanges],
    [InsightKey.GlucoseStandardDeviation]: [...allRanges],
    [InsightKey.GlucoseTotalUnicorns]: [...allRanges],
    [InsightKey.InsulinAverageBasal]: [...oneDayOrLonger],
    [InsightKey.InsulinAverageBolus]: [...oneDayOrLonger],
    [InsightKey.InsulinAverage]: [...oneDayOrLonger],
    [InsightKey.InsulinTotalBasal]: [...allRanges],
    [InsightKey.InsulinTotalBolus]: [...allRanges],
    [InsightKey.InsulinTotal]: [...allRanges],
    [InsightKey.MiniGraph]: [...oneDayOrShorter],
    [InsightKey.TimeInRange]: [upToNow],
  }
}

// TODO use insightLookupByKey ?
export const insightRangesByKey: Readonly<
  Record<InsightKey, Readonly<Insight["range"][]>>
> = copyInsightRangesByKey()
